
import { defineComponent, ref, watch, computed, PropType } from 'vue';
import type { INoticeDetailRes } from '@/api/content-manage/type.d';

export default defineComponent({
  emits: ['update:visible'],
  props: {
    noticeContent: {
      type: Object as PropType<INoticeDetailRes>,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const formData = ref<INoticeDetailRes>({
      noticeId: '', // 通知id
      noticeCode: '', // 通知编码
      updateSystem: [], // 更新系统
      noticeSystem: [], // 通知系统
      theme: '', // 通知栏
      content: '', // 具体更新内容
      creatorName: '', // 发布人名
      publishTime: '', // 开始通知时间
      publishEndTime: '', // 结束通知时间
      status: '', // 状态
    });

    watch(props, (val) => {
      if (val.visible && props.noticeContent.noticeId) {
        formData.value = props.noticeContent;
      } else {
        formData.value = Object.assign({}, {
          noticeId: '', // 通知id
          noticeCode: '', // 通知编码
          updateSystem: [], // 更新系统
          noticeSystem: [], // 通知系统
          theme: '', // 通知栏
          content: '', // 具体更新内容
          creatorName: '', // 发布人名
          publishTime: '', // 开始通知时间
          publishEndTime: '', // 结束通知时间
          status: '', // 状态
        });
      }
    });

    const handleClose = () => {
      emit('update:visible', false);
    };
    return {
      handleClose,
      selfVisible,
      formData,
    };
  },

});

